import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';

export const Price = ({lineItem}: {lineItem: LineItemModel}) => {
  const {showComparePriceWhenDifferent} = useControllerProps().cartStore;

  const crossedOutPrice =
    lineItem.priceBeforeDiscounts.formattedConvertedAmount || lineItem.fullPrice.formattedConvertedAmount;

  return (
    <div className={s.prices}>
      {crossedOutPrice &&
        (!showComparePriceWhenDifferent || crossedOutPrice !== lineItem.price.formattedConvertedAmount) && (
          <span
            data-hook={CartItemDataHook.ComparePrice}
            data-wix-line-full-item-price={CartItemDataHook.ComparePrice}
            className={s.comparePrice}>
            {crossedOutPrice}
          </span>
        )}
      {lineItem.price.formattedConvertedAmount && (
        <span data-hook={CartItemDataHook.Price} className={s.price} data-wix-line-item-price={CartItemDataHook.Price}>
          {lineItem.price.formattedConvertedAmount}
        </span>
      )}
    </div>
  );
};
